const baseUrl = process.env.VUE_APP_API_NOTIFICATION_URL + '/api'
const resource = baseUrl + '/campaigns'

export default $axios => ({
	create(payload, setting) {
		return $axios.post(`${resource}`, payload, setting)
	},
})
